import { c as _c } from "react/compiler-runtime";
import { Link } from '@/components/links';
import { Category } from './functions/getCategories';
import { LINKS } from '@/constants/links';
import Image from 'next/image';
import ChevronRight from '@/assets/icons/heroIcons/Chevron-right.svg';
import { logEvent } from '@/analytics/events';
interface Props {
  category: Category;
}
export function CategoryItem(props) {
  const $ = _c(18);
  const {
    category
  } = props;
  const t0 = `discountCategory_${category.id}`;
  const t1 = `discountCategory_${category.id}`;
  let t2;
  if ($[0] !== category.slug) {
    t2 = LINKS().discountsCategory(category.slug);
    $[0] = category.slug;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== category.name) {
    t3 = () => {
      logEvent("select_category", {
        content_name: category.name
      });
    };
    $[2] = category.name;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = `/images/sections/discounts/category/${category.slug}.png`;
  let t5;
  if ($[4] !== category.name || $[5] !== t4) {
    t5 = <Image width={80} height={64} src={t4} alt={category.name} className="h-10 w-13 lg:h-16 lg:w-20" />;
    $[4] = category.name;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== category.name) {
    t6 = <span className="text-sm font-semibold text-gray-900 lg:text-xl">{category.name}</span>;
    $[7] = category.name;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <ChevronRight className="ml-auto hidden lg:block" />;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== category.id || $[11] !== t0 || $[12] !== t1 || $[13] !== t2 || $[14] !== t3 || $[15] !== t5 || $[16] !== t6) {
    t8 = <Link analyticsParam={t0} testId={t1} to={t2} onClick={t3} key={category.id} className="flex items-center gap-2 rounded-lg bg-blue-50 py-3 pr-2 pl-2 no-underline shadow-xs transition-colors hover:bg-white md:rounded-2xl lg:gap-4 lg:pr-5">{t5}{t6}{t7}</Link>;
    $[10] = category.id;
    $[11] = t0;
    $[12] = t1;
    $[13] = t2;
    $[14] = t3;
    $[15] = t5;
    $[16] = t6;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  return t8;
}